import { render, staticRenderFns } from "./CardHome.vue?vue&type=template&id=527e7560"
import script from "./CardHome.vue?vue&type=script&lang=js"
export * from "./CardHome.vue?vue&type=script&lang=js"
import style0 from "./CardHome.vue?vue&type=style&index=0&id=527e7560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports